import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function startCheckout(packageId, { email, name, path } = {}) {
  const origin_url = window.location.origin;
  const { data } = await api.post("/checkout/session", {
    package_id: packageId,
    origin_url,
    email,
    name,
    path,
  });
  if (data?.url) {
    window.location.href = data.url;
  }
  return data;
}

export async function getCheckoutStatus(sessionId) {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
}

export async function getPosts() {
  const { data } = await api.get("/posts");
  return data;
}

export async function getPost(slug) {
  const { data } = await api.get(`/posts/${slug}`);
  return data;
}

export async function subscribeNewsletter(payload) {
  const { data } = await api.post("/newsletter", payload);
  return data;
}

export function adminHeaders(token) {
  return { headers: { "X-Admin-Token": token } };
}
